// @ts-nocheck
/* Store Custom File - from getGeoCodeFromAddress.ts */
export const getGeoCodeFromAddressInCanada = (address: string) =>
    new Promise<google.maps.GeocoderResult[]>((resolve, reject) => {
        if (address && address.trim()) {
            const geocoder = new google.maps.Geocoder();
            /* Store Custom Code - Start */
            const componentRestrictions = { country: "Canada" };
            /* Store Custom Code - End */
            // Store Custom Code - Added componentRestrictions
            geocoder.geocode(
                { address, componentRestrictions },
                (results: google.maps.GeocoderResult[], status: any) => {
                    if (status === google.maps.GeocoderStatus.OK) {
                        resolve(results);
                    } else {
                        reject(status);
                    }
                },
            );
        } else {
            reject(google.maps.GeocoderStatus.ZERO_RESULTS);
        }
    });
